goog.provide("shadow.js.shim.module$dayjs$plugin$isoWeek");
goog.provide("module$shadow_js_shim_module$dayjs$plugin$isoWeek");
shadow.js.shim.module$dayjs$plugin$isoWeek = shadow.js.nativeProvides["dayjs/plugin/isoWeek"] = require("dayjs/plugin/isoWeek");
module$shadow_js_shim_module$dayjs$plugin$isoWeek.default = shadow.js.shim.module$dayjs$plugin$isoWeek;
